import { Injectable } from '@angular/core';
import { HttpApiServiceBase } from './http-api-service-base';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Organisation } from '../domain/organisation';
import { AddPropertyToDomainRequest } from './request/add-property-to-domain-request';
import { AddPropertyToDomainResponse } from './response/add-property-to-domain-response';

@Injectable({
   providedIn: 'root'
})
export class DomainService extends HttpApiServiceBase {
   constructor(private http: HttpClient) {
      super();
   }

   getAllPublic(): Observable<Organisation[]> {
      return this.http.get<Organisation[]>(`${environment.apiEndpoint}/domain`);
   }

   addPropertyToDomain(
      orgId: number,
      propId: number,
      request: AddPropertyToDomainRequest
   ): Observable<AddPropertyToDomainResponse> {
      return this.http.post<AddPropertyToDomainResponse>(
         `${environment.apiEndpoint}/domain/${encodeURIComponent(orgId)}/property/${encodeURIComponent(propId)}`,
         request
      );
   }
}
